import { useEffect, useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { fetchEmployeeLeaveLedgerSummary } from "services/employeeLeave";

const EmployeeLeaveDropdown = ({ errors, control, setValue, getValues, watch, rowData, onChange }) => {
  const selectedEmployeeId = watch("leave_id");

  const employeeName =
    rowData?.employee_obj?.employee_name ||
    rowData?.employee_name ||
    getValues()?.employee_name;

  const {
    data: employees,
    isLoading,
    error,
  } = useQuery(["employee-leave-dropdown"], () => fetchEmployeeLeaveLedgerSummary(), {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  const modifiedData = useMemo(() => {
    return (
      employees?.data?.data?.map((ele) => ({
        value: ele?.leave_id,
        label: ele?.leave_name,
      })) || []
    );
  }, [employees]);

  const options = useMemo(() => modifiedData, [modifiedData]);

  const selectedOption = useMemo(() => {
    return (
      options?.find((option) => option?.value === selectedEmployeeId) ||
      options?.find((option) => option?.label === employeeName) ||
      null
    );
  }, [options, selectedEmployeeId, employeeName]);

  // useEffect(() => {
  //   if (rowData && options?.length) {
  //     const rowDataOption = options?.find(
  //       (option) => option?.value === rowData?.leave_id[0]?.employee_code_id
  //     );
  //     setValue("leave_id", rowDataOption?.value);
  //   }
  // }, [rowData, options, setValue]);

  useEffect(() => {
    if (rowData?.leave_id && Array.isArray(rowData.leave_id) && rowData.leave_id.length > 0 && options?.length) {
      const rowDataOption = options.find(
        (option) => option?.value === rowData?.leave_id[0]?.employee_code_id
      );
      setValue("leave_id", rowDataOption?.value);
    }
  }, [rowData, options, setValue]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Employees</div>;

  return (
    <Controller
      name="leave_id"
      control={control}
      rules={{ required: "Leave is required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          value={selectedOption || null}
          placeholder="Select Leave"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          // onChange={(selectedOption) => {
          //   const value = selectedOption ? selectedOption?.value : "";
          //   field.onChange(value);
          //   setValue("leave_id", value);
          //   setValue("employee_name", selectedOption ? selectedOption?.label : "");
          // }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption?.value : "";
            field.onChange(value);
            setValue("leave_id", value);
            setValue("employee_name", selectedOption ? selectedOption?.label : "");

            // Call the onChange prop if it exists
            if (onChange) {
              onChange(selectedOption);
            }
          }}
          className={`react-select-container ${errors?.leave_id ? "is-invalid" : ""
            }`}
        />
      )}
    />
  );
};

export default EmployeeLeaveDropdown;